<div class="sub-header">
  <div class="header-info">
    @for (header of headers; track header; let i = $index) {
      <div class="column" [ngStyle]="{'width': colStyle[0].width, 'margin-right': colStyle[0].marginright}">
        <div>
          @if (header.FIELD != 'NAME' && header.FIELD != 'CONTACT' && header.FIELD != 'FACILITY_LOCATION' && header.FIELD != 'PRODUCT_SERIES_NUMBER' && header.FIELD != 'CERTIFICATE_NUMBER' && header.FIELD != 'CERTIFICATION_NUMBER' && header.FIELD != 'SELF_CERTIFICATION' && header.FIELD != 'REGISTRATION_NUMBER' && header.FIELD != 'PRODUCT_DESIGNATION' && header.FIELD != 'END_USES' && header.FIELD != 'NONFOOD_CATEGORY'  && header.FIELD != 'WATER_CONTACT_TEMP'  && header.FIELD != 'WATER_CONTACT_MATERIAL' && header.FIELD != 'FOR_USE_WITH' && header.FIELD != 'MAX_PRESSURE' && header.FIELD != 'MAX_TEMP' && header.FIELD != 'TRADE_DESIGNATION' && header.FIELD != 'PRODUCT_DESCRIPTION' && header.FIELD != 'MODEL') {
            <div>
              <p>{{header.TITLE}}</p>
              @if (info[header.FIELD] != null) {
                <label>
                  {{info[header.FIELD]}}
                </label>
              }
            </div>
          }
          @if (header.FIELD == 'NAME' && info?.NAME != null) {
            <div>
              <p>{{header.TITLE}}</p>
              @for (com_add of info.NAME; track com_add) {
                <span>
                  <label>{{com_add}}</label><br>
                </span>
              }
            </div>
          }
          @if (header.FIELD == 'CONTACT' && (info.CONTACT != null || info.COMPANY_CONTACT_URL != null)) {
            <div>
              <p>{{header.TITLE}}</p>
              @if (info.CONTACT != null) {
                <span>
                  @for (contact of contacts; track contact) {
                    <span>
                      <label>{{contact}}</label><br>
                    </span>
                  }
                </span>
              }
              @if (info.COMPANY_CONTACT_URL && info.COMPANY_CONTACT_URL != null) {
                <label>
                  <a (click)="goToWebsite(info.COMPANY_CONTACT_URL)" style="font-family: Inter, sans-serif;
                  color: #2d74da; cursor: pointer;">Visit this Company's Website</a>
                </label>
              }
            </div>
          }

          @if (header.FIELD == 'TRADE_DESIGNATION') {
            <div>
              <p>{{header.TITLE}}</p>
              @if (info.LOGO_URL != null) {
                <label class="tradeName">
                  <img class="padding9 cursor-pointer" [src]="info.LOGO_URL" />
                </label>
              }
              @if (info.LOGO_URL == null) {
                <label>
                  {{info[header.FIELD]}}
                </label>
              }
            </div>
          }

          @if (header.FIELD == 'END_USES' && header.DATA_TYPE === 'HYPERLINK') {
            <div>
              <p>{{header.TITLE}}</p>        
              <label class="grid-atag" (click)="windowClickEvt(header.FIELD)">
                {{info[header.FIELD]}}
              </label>
              @if (header.DATA_TYPE != 'HYPERLINK') {
                <label>
                  {{info[header.FIELD]}}
                </label>
              }
            </div>
          }
          @if (header.FIELD == 'END_USES' && header.DATA_TYPE != 'HYPERLINK') {
            <div>
              <p>{{header.TITLE}}</p>
              <label>
                {{info[header.FIELD]}}
              </label>
            </div>
          }

          @if (header.FIELD == 'NONFOOD_CATEGORY' && header.DATA_TYPE === 'HYPERLINK') {
            <div>
              <p>{{header.TITLE}}</p>        
              <label class="grid-atag" (click)="windowClickEvt(header.FIELD)">
                {{info[header.FIELD]}}
              </label>
              @if (header.DATA_TYPE != 'HYPERLINK') {
                <label>
                  {{info[header.FIELD]}}
                </label>
              }
            </div>
          }
          @if (header.FIELD == 'NONFOOD_CATEGORY' && header.DATA_TYPE != 'HYPERLINK') {
            <div>
              <p>{{header.TITLE}}</p>
              <label>
                {{info[header.FIELD]}}
              </label>
            </div>
          }
          @if (header.FIELD == 'WATER_CONTACT_TEMP' && header.DATA_TYPE === 'HYPERLINK') {
            <div>
              <p>{{header.TITLE}}</p>        
              <label class="grid-atag" (click)="windowClickEvt(header.FIELD)">
                {{info[header.FIELD]}}
              </label>
              @if (header.DATA_TYPE != 'HYPERLINK') {
                <label>
                  {{info[header.FIELD]}}
                </label>
              }
            </div>
          }
          @if (header.FIELD == 'WATER_CONTACT_TEMP' && header.DATA_TYPE != 'HYPERLINK') {
            <div>
              <p>{{header.TITLE}}</p>        
              <label>
                {{info[header.FIELD]}}
              </label>
            </div>
          }
          @if (header.FIELD == 'WATER_CONTACT_MATERIAL' && header.DATA_TYPE === 'HYPERLINK') {
            <div>
              <p>{{header.TITLE}}</p>        
              <label class="grid-atag" (click)="windowClickEvt(header.FIELD)">
                {{info[header.FIELD]}}
              </label>
              @if (header.DATA_TYPE != 'HYPERLINK') {
                <label>
                  {{info[header.FIELD]}}
                </label>
              }
            </div>
          }
          @if (header.FIELD == 'WATER_CONTACT_MATERIAL' && header.DATA_TYPE != 'HYPERLINK') {
            <div>
              <p>{{header.TITLE}}</p>        
              <label>
                {{info[header.FIELD]}}
              </label>
            </div>
          }
          @if (header.FIELD == 'FOR_USE_WITH') {
            <div>
              <p>{{header.TITLE}}</p>        
              <label class="grid-atag" (click)="windowClickEvt(header.FIELD)">
                {{info[header.FIELD]}}
              </label>
            </div>
          }
          @if (header.FIELD == 'MAX_PRESSURE') {
            <div>
              <p>{{header.TITLE}}</p>        
              @if (info.MAX_PRESSURE_LINK && info.MAX_PRESSURE_LINK != null) {
                <label class="grid-atag" (click)="windowClickEvt(header.FIELD)">
                  {{info[header.FIELD]}}
                </label>
              }
              @if (info.MAX_PRESSURE_LINK == null) {
                <label>
                  {{info[header.FIELD]}}
                </label>
              }
              @if (info.MAX_PRESSURE == '') {
                <label>
                  -
                </label>
              }
            </div>
          }
          @if (header.FIELD == 'MAX_TEMP') {
            <div>
              <p>{{header.TITLE}}</p>        
              @if (info.MAX_TEMP_LINK && info.MAX_TEMP_LINK != null) {
                <label class="grid-atag" (click)="windowClickEvt(header.FIELD)">
                  {{info[header.FIELD]}}
                </label>
              }
              @if (info.MAX_TEMP_LINK == null) {
                <label>
                  {{info[header.FIELD]}}
                </label>
              }
              @if (info.MAX_TEMP == '') {
                <label>
                  -
                </label>
              }
            </div>
          }
          @if (header.FIELD == 'FACILITY_LOCATION') {
            <div>
              <p>{{header.TITLE}}</p>        
              @if (info.FACILITY_LOCATION_CERTLINK != null) {
                <label class="grid-atag" (click)="facilityDownloadData(info?.FACILITY_LOCATION_CERTLINK)">
                  {{info[header.FIELD]}}
                </label>
              }
              @if (info.FACILITY_LOCATION_CERTLINK == null) {
                <label>
                  {{info[header.FIELD]}}
                </label>
              }
            </div>
          }
          @if (header.FIELD == 'PRODUCT_SERIES_NUMBER') {
            <div>
              <p>{{header.TITLE}}</p>        
              @if (info.PRODUCT_SERIES_NUMBER_LINK != null) {
                <label class="grid-atag" (click)="facilityDownloadData(info?.PRODUCT_SERIES_NUMBER_LINK)">
                  {{info[header.FIELD]}}
                </label>
              }
              @if (info.PRODUCT_SERIES_NUMBER_LINK == null) {
                <label>
                  {{info[header.FIELD]}}
                </label>
              }
            </div>
          }
          @if (header.FIELD == 'CERTIFICATE_NUMBER') {
            <div>
              <p>{{header.TITLE}}</p>        
              @if (info.CERTIFICATE_NUMBER_LINK != null) {
                <label class="grid-atag" (click)="certDownloadData(info?.CERTIFICATE_NUMBER_LINK)">
                  {{info[header.FIELD]}}
                </label>
              }
              @if (info.CERTIFICATE_NUMBER_LINK == null) {
                <label>
                  {{info[header.FIELD]}}
                </label>
              }
            </div>
          }
          @if (header.FIELD == 'CERTIFICATION_NUMBER') {
            <div>
              <p>{{header.TITLE}}</p>        
              @if (info.CERTIFICATION_NUMBER_LINK != null) {
                <label class="grid-atag" (click)="registrationDownloadData(info?.CERTIFICATION_NUMBER_LINK)">
                  {{info[header.FIELD]}}
                </label>
              }
              @if (info.CERTIFICATION_NUMBER_LINK == null) {
                <label>
                  {{info[header.FIELD]}}
                </label>
              }
            </div>
          }
          @if (header.FIELD == 'SELF_CERTIFICATION') {
            <div>
              <p>{{header.TITLE}}</p>        
              @if (info.SELF_CERTIFICATION_LINK != null) {
                <label class="grid-atag" (click)="certDownloadData(info?.SELF_CERTIFICATION_LINK)">
                  {{info[header.FIELD]}}
                </label>
              }
              @if (info.SELF_CERTIFICATION_LINK == null) {
                <label>
                  {{info[header.FIELD]}}
                </label>
              }
            </div>
          }
          @if (header.FIELD == 'REGISTRATION_NUMBER'  && header.DATA_TYPE === 'HYPERLINK') {
            <div>
              <p>{{header.TITLE}}</p>        
              @if (info.REGISTRATION_NUMBER_LINK != null) {
                <label class="grid-atag" (click)="registrationDownloadData(info?.REGISTRATION_NUMBER_LINK)">
                  {{info[header.FIELD]}}
                </label>
              }
              @if (info.REGISTRATION_NUMBER_LINK == null) {
                <label>
                  {{info[header.FIELD]}}
                </label>
              }
            </div>
          }
          @if (header.FIELD == 'REGISTRATION_NUMBER'  && header.DATA_TYPE != 'HYPERLINK') {
            <div>
              <p>{{header.TITLE}}</p>        
              <label>
                {{info[header.FIELD]}}
              </label>
            </div>
          }
          @if (header.FIELD == 'PRODUCT_DESIGNATION'  && header.DATA_TYPE === 'HYPERLINK') {
            <div>
              <p>{{header.TITLE}}</p>        
              @if (info.PRODUCT_DESIGNATION_LINK != null) {
                <label class="grid-atag" (click)="productDesignationDownloadData(info?.PRODUCT_DESIGNATION_LINK)">
                  {{info[header.FIELD]}}
                </label>
              }
              @if (info.PRODUCT_DESIGNATION_LINK == null) {
                <label>
                  {{info[header.FIELD]}}
                </label>
              }
            </div>
          }
          @if (header.FIELD == 'PRODUCT_DESIGNATION'  && header.DATA_TYPE != 'HYPERLINK') {
            <div>
              <p>{{header.TITLE}}</p>        
              <label>
                {{info[header.FIELD]}}
              </label>
            </div>
          }
          @if (header.FIELD == 'MODEL') {
            <div>
              <p>{{header.TITLE}}</p>
              @if (info.MODEL_LINK != null) {
                <label class="grid-atag" (click)="certDownloadData(info.MODEL_LINK)">
                  {{info[header.FIELD]}}
                </label>
              }
              @if (info.MODEL_LINK == null) {
                <label>
                  {{info[header.FIELD]}}
                </label>
              }
            </div>
          }
          @if (header.FIELD == 'PRODUCT_DESCRIPTION') {
            <div>
              <p>{{header.TITLE}}</p>
              @if (info[header.FIELD] != null) {
                <label>
                  {{info[header.FIELD]}}
                </label>
              } @else {
                @if (info.ITEM_DESCRIPTION != null) {
                  <label>
                    {{info.ITEM_DESCRIPTION}}
                  </label>
                }
              }
            </div>
          }

        </div>
      </div>
    }
  </div>
</div>

@if (isPopupEnable) {
  <kendo-window title="{{windowTitle}}" (close)="close()">
    <div class="new_window" style="width: 100%; height:100%">
      @if (isLoader) {
        <div class="custom-loader"></div>
      }
      <iframe [src]="iFrameUrl" (load)="onLoadiFrame()"></iframe>
    </div>
  </kendo-window>
}
@if (isErrorPopUpEnable) {
  <kendo-dialog title="{{errorMsgObj.errorMsgTitle}}" (close)="closeError('cancel')">
    <span style="font-size: 20px; font-weight: 900;">{{errorMsgObj.errorMsgLbl}}</span>
    <p>{{errorMsgObj.errorMsgTxt}}</p> 
  </kendo-dialog>
}